import { RequestStatus } from '~/pages/projectDetails/utilities/common';

export const projectFilter = (projectId: string) => [
  {
    id: Math.random().toString(),
    type: 'group',
    condition: 'and',
    children: [
      {
        id: Math.random().toString(),
        type: 'rule',
        columnId: 'project.projectId',
        value: projectId,
        operator: 'isEqualTo',
      },
      {
        id: Math.random().toString(),
        type: 'rule',
        columnId: 'organization.isInternal',
        value: false,
        operator: 'isFalse',
      },
      {
        id: Math.random.toString(),
        type: 'rule',
        columnId: 'requestStatus',
        value: RequestStatus.Complete,
        operator: 'isNotEqualTo',
      },
      {
        id: Math.random().toString(),
        type: 'rule',
        columnId: 'requestStatus',
        value: RequestStatus.Cancelled,
        operator: 'isNotEqualTo',
      },
      {
        id: Math.random().toString(),
        type: 'rule',
        columnId: 'requestStatus',
        value: RequestStatus.Dismissed,
        operator: 'isNotEqualTo',
      },
    ],
  },
];
